export enum PaymentTypeCode {
  Alipay = 1, //支付宝
  Wechat, // 微信
  Paypal,
  Stripe = 26,
  CPUAlipay = 30, //支付宝充值CPU青云券
  CPUWechat, //微信充值CPU青云券
  SubUserTransfer = 33, // 子账号转入
  GPUAlipay = 41, //支付宝充值GPU青云券
  GPUWechat, //微信充值GPU青云券
  DesktopWechat = 64, // 微信充值云制作币
  DesktopAlipay = 65, // 支付宝充值云制作币
}

export enum PaymentPurposeCode {
  OrdinaryRecharge = 1, // 普通充值
  ActivityRecharge = 4, // 活动充值
  FirstRecharge = 5, // 首充
}

export enum OrderPaymentTypeCode {
  OrdinaryOrder = 1, // 现金充值
  QingCloudCPUOrder, // CPU青云券充值
  MemberOrder, // 会员充值
  QingCloudGPUOrder, // GPU青云券充值
  Desktop = 6, // 云制作充值
}

export enum rechargeChannelsCode { // 充值渠道
  Default = 0, // 默认
  Web, // 网页端
  Client, // 客户端
  MiniPrograms, // 小程序
}

export enum PayMethod {
  Ali = 1,
}

export const QRCODE_QUERY_MAP = {
  platform: "p",
  userKey: "k",
  languageFlag: "l",
  orderType: "o",
  amount: "a",
  payType: "y",
  mount: "m",
  type: "t",
  rechargeGoal: "r",
  activityDetailId: "i",
  timeStamp: "s",
  noCertifiedSubmit: "c",
  rechargeChannels: "h",
  couponNO: "n", // 兑换券编号
};
